<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px">
      <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img src="/img/tree/Wizard2-Soltero-02.svg" style="width: 100%; height: auto" alt />
          </div>
        </mdb-row>
      </mdb-container>
    </div>
    <div style="background-color: #f7f7f7; padding-bottom: 3rem" class="mt-1 pt-1">
      <mdb-container style="
                                            max-width: 97% !important;
                                            padding-bottom: 2rem;
                                            background-color: #fff;
                                            -webkit-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
                                            -moz-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
                                            box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
                                          " class="mt-5">
        <mdb-row class="pt-5 pr-5">
          <mdb-col class="text-right">
            <router-link to="/home">
              <p style="
                                                    font-size: 30px;
                                                    cursor: pointer;
                                                    color: #e0e0e0;
                                                    font-weight: 700;
                                                  ">
                x
              </p>
            </router-link>
          </mdb-col>
        </mdb-row>
        <div class="form-margins">
          <mdb-row class="text-left">
            <mdb-col>
              <h3 class="t1-title" style="margin-top: 0">02 PAGO ONLINE</h3>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-2">
            <mdb-col>
              <h4 class="t1-subtitle">
                Selecciona si deseas ser usuario propietario, usufructuario, o
                renta, elige el tipo de acción que deseas adquirir y procede al
                pago.
              </h4>
            </mdb-col>
          </mdb-row>
          <div style="
                                                border: 1px solid #3a8a65;
                                                margin-top: 15px;
                                                border-radius: 5px;
                                              ">
            <div style="padding-left: 20px; padding-right: 20px">
              <mdb-row class="mt-5">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">Selecciona el tipo de usuario que deseas ser:</label>
                  </div>
                </mdb-col>
                <mdb-col v-for="(at, index) in applicantT" :key="at.applicantTypeValue" lg="3" md="4" sm="12"
                  style="margin-bottom: 10px">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="buyerType" :id="at.applicantTypeValue" v-model="buyerType"
                        :value="at.applicantTypeValue" />
                      <label :for="at.applicantTypeValue">
                        <span :class="
                          buyerType == at.applicantTypeValue
                            ? 'form__label-active'
                            : ''
                        "></span>
                        {{ at.applicantTypeValue }}
                      </label>
                    </div>
                    <input @mouseleave="mouseLeaveIcon(null)" @mouseover="mouseOverIcon(index)" type="image" :id="index"
                      :src="'/img/icons/' + helpIcon" />
                    <mdb-card v-if="showCard == index" style="
                                                          font-size: 15px;
                                                          position: absolute;
                                                          top: -7rem;
                                                          padding: 10px;
                                                          border-radius: 1rem;
                                                        ">{{ at.description }}</mdb-card>
                  </div>
                </mdb-col>
              </mdb-row>
              <!--INICIO TIPO trámite-->
              <mdb-row class="mt-5">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">Selecciona el tipo de trámite que deseas realizar:</label>
                  </div>
                </mdb-col>
                <mdb-col v-show="buyerType == 'Propietario'" lg="3" md="4" sm="12" style="margin-bottom: 10px"
                  v-for="(proceeding, index) in applicantT[0].proceedingTypes" :key="index">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="ProceedingType" :id="proceeding.proceedingTypeValue"
                        v-model="ProceedingType" :value="proceeding.proceedingTypeValue" />
                      <label :for="proceeding.proceedingTypeValue">
                        <span :class="
                          ProceedingType == proceeding.proceedingTypeValue
                            ? 'form__label-active'
                            : ''
                        "></span>
                        {{ proceeding.proceedingTypeValue }}
                      </label>
                    </div>
                    <input @mouseleave="mouseLeaveIcon(null)" @mouseover="mouseOverIcon(proceeding.id)" type="image"
                      :id="proceeding.id" :src="'/img/icons/' + helpIcon" />
                    <mdb-card v-if="showCard == proceeding.id" style="
                                                          font-size: 15px;
                                                          position: absolute;
                                                          top: -7rem;
                                                          padding: 10px;
                                                          border-radius: 1rem;
                                                        ">{{ proceeding.description }}</mdb-card>
                  </div>
                </mdb-col>
                <mdb-col v-show="buyerType == 'Usufructuario'" lg="3" md="4" sm="12" style="margin-bottom: 10px"
                  v-for="proceeding in applicantT[1].proceedingTypes" :key="proceeding.id">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="ProceedingType" :id="proceeding.id" v-model="ProceedingType"
                        :value="proceeding.proceedingTypeValue" />
                      <label :for="proceeding.id">
                        <span :class="
                          ProceedingType == proceeding.proceedingTypeValue
                            ? 'form__label-active'
                            : ''
                        "></span>
                        {{ proceeding.proceedingTypeValue }}
                      </label>
                    </div>
                    <input @mouseleave="mouseLeaveIcon(null)" @mouseover="mouseOverIcon(proceeding.id)" type="image"
                      :id="proceeding.id" :src="'/img/icons/' + helpIcon" />
                    <mdb-card v-if="showCard == proceeding.id" style="
                                                          font-size: 15px;
                                                          position: absolute;
                                                          top: -7rem;
                                                          padding: 10px;
                                                          border-radius: 1rem;
                                                        ">{{ proceeding.description }}</mdb-card>
                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row v-if="buyerType == 'Usufructuario'">
                <mdb-col md="5">
                  <div class="form__group">
                    <label class="form__label" for="anteriorPropietario">Nombre completo del propietario de la
                      {{
                        ProceedingType == "Rentar solo Acción"
                        ? "acción"
                        : "casa"
                      }}:</label>
                    <input type="text" maxlength="50" id="anteriorPropietario" class="form__input"
                      placeholder="Nombre completo del propietario" v-model="namePropietario" />
                    <validation-error field="el nombre del propietario"
                      message="Introduce el nombre del propietario anterior" :validation="$v.namePropietario" />
                  </div>
                </mdb-col>
                <mdb-col v-if="ProceedingType != 'Rentar solo Casa'" md="3">
                  <label class="form__label" for="NAccion">No. de acción
                    {{
                      ProceedingType == "Rentar solo Acción" ? "" : "a rentar"
                    }}:</label>
                  <input type="text" v-mask="'#####'" id="NAccion" class="form__input" placeholder="No. de acción"
                    v-model="accion" />
                  <validation-error field="el no. de acción" message="Introduce el número de acción a rentar"
                    :validation="$v.accion" />
                </mdb-col>
                <mdb-col v-if="ProceedingType != 'Rentar solo Acción'" md="5">
                  <label class="form__label" for="domicilio">Domicilio de la casa a rentar:</label>
                  <input type="text" id="domicilio" class="form__input" placeholder="Ingresa el domicilio" maxlength="100"
                    v-model="domicilio" />
                  <validation-error field="el domicilio" message="Introduce el domicilio de la casa a rentar"
                    :validation="$v.domicilio" />
                </mdb-col>
              </mdb-row>

              <!--VENTA NUEVA O TRANSPASO-->
              <mdb-row v-show="buyerType == 'Propietario'" class="mt-5">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">¿Es venta nueva o traspaso?:</label>
                  </div>
                </mdb-col>

                <mdb-col lg="3" md="4" sm="12" style="margin-bottom: 10px" v-for="(sales, index) in salesTypes"
                  :key="index">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="paymentType" :id="sales.subProceedingTypeValue" v-model="paymentType"
                        :value="sales.subProceedingTypeValue" />
                      <label :for="sales.subProceedingTypeValue">
                        <span :class="
                          paymentType == sales.subProceedingTypeValue
                            ? 'form__label-active'
                            : ''
                        "></span>
                        {{ sales.subProceedingTypeValue }}
                      </label>
                    </div>
                    <input @mouseleave="mouseLeaveIcon(null)" @mouseover="mouseOverIcon(sales.id)" type="image"
                      :id="sales.id" :src="'/img/icons/' + helpIcon" />
                    <mdb-card v-if="showCard == sales.id" style="
                                                          font-size: 15px;
                                                          position: absolute;
                                                          top: -7rem;
                                                          padding: 10px;
                                                          border-radius: 1rem;
                                                        ">{{ sales.description }}</mdb-card>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="paymentType == 'Traspaso'">
                <mdb-col lg="3" md="4" sm="12" style="margin-bottom: 10px" v-if="buyerType == 'Propietario'">
                  <div v-show="escUrl == null" class="form__group">
                    <label for="esc-input" class="btn-label">
                      <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                      SUBIR ESCRITURAS
                    </label>
                    <input type="file" accept="application/pdf" name="file" id="esc-input" style="visibility: hidden"
                      @change="uploadEscritura" />
                  </div>
                  <div>
                    <HelperMessage v-show="showErrorEscrituras" type="error" text="Sube las escrituras de tu propiedad" />
                  </div>
                  <div v-show="escUrl != null" class="input-group">
                    <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>
                    <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"
                      @click="viewPdf(escUrl, 'Escrituras')" />

                    <button type="button" class="btn btn-delete"
                      @click="
                        escUrl = null;
                      cleanInputFile('esc-input');
                                                                                                                                                                                                                                                                                                                                                                                                                                  "
                      style="padding: 3px; position: inherit; top: 4px">
                      <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                    </button>
                  </div>
                </mdb-col>
                <mdb-col lg="3" md="4" sm="12" style="margin-bottom: 10px" v-if="buyerType == 'Propietario'">
                  <div v-show="predialUrl == null" class="form__group">
                    <label for="predial-input" class="btn-label">
                      <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                      SUBIR PAGO PREDIAL
                    </label>
                    <input type="file" accept="application/pdf" name="file" id="predial-input" style="visibility: hidden"
                      @change="uploadPredial" />
                    <HelperMessage type="default"
                      text="El pago del predial debe estar vigente, debe ser del año actual." />
                  </div>

                  <div>
                    <HelperMessage v-show="showErrorPredial" type="error" text="Sube tu pago predial" />
                  </div>

                  <div v-show="predialUrl != null" class="input-group">
                    <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>
                    <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"
                      @click="viewPdf(predialUrl, 'Predial')" />
                    <button type="button" class="btn btn-delete"
                      @click="
                        predialUrl = null;
                      cleanInputFile('predial-input');
                                                                                                                                                                                                                                                                                                                                                                                                                                  "
                      style="padding: 3px; position: inherit; top: 4px">
                      <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                    </button>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="buyerType == 'Propietario'" class="mb-5">
                <mdb-col v-if="ProceedingType == 'Adquirir Casa'" md="5">
                  <div class="form__group">
                    <label class="form__label" for="domicilio">Domicilio de la casa:</label>
                    <input type="text" id="domicilio" class="form__input" placeholder="Ingresa el domicilio"
                      maxlength="100" v-model="domicilio" />
                    <validation-error field="el domicilio" message="Introduce el domicilio de la casa"
                      :validation="$v.domicilio" />
                  </div>
                </mdb-col>
                <mdb-col md="4">
                  <div class="form__group">
                    <label class="form__label" for="NTerreno">Número de terreno:</label>
                    <input type="text" maxlength="20" id="NTerrero" class="form__input"
                      placeholder="Ingresa el No. de terreno" v-model="terreno" />
                    <validation-error field="el número terreno" message="Introduce el numero del terreno"
                      :validation="$v.terreno" />
                  </div>
                </mdb-col>
                <mdb-col v-if="paymentType == 'Traspaso'" md="5">
                  <div class="form__group">
                    <label class="form__label" for="anteriorPropietario">Nombre completo del propietario
                      anterior:</label>
                    <input type="text" maxlength="50" id="anteriorPropietario" class="form__input"
                      placeholder="Nombre completo del propietario anterior" v-model="namePropietario" />
                    <validation-error field="el nombre del propietario anterior"
                      message="Introduce el nombre del propietario anterior" :validation="$v.namePropietario" />
                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row v-if="buyerType == 'Propietario'" class="mt-3">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">¿A nombre de quién quedará la propiedad?:</label>
                  </div>
                </mdb-col>
                <mdb-col lg="3" md="4" sm="12" style="margin-bottom: 10px" v-if="buyerType == 'Propietario'">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="titular" id="titular" v-model="titularType" value="yo" />
                      <label for="titular">
                        <span :class="
                          titularType == 'yo' ? 'form__label-active' : ''
                        "></span>Yo, el solicitante
                      </label>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col md="4" style="margin-bottom: 10px" v-if="buyerType == 'Propietario'">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="titular" id="rentacasaaccionusuf" v-model="titularType" value="otro" />
                      <label for="rentacasaaccionusuf">
                        <span :class="
                          titularType == 'otro' ? 'form__label-active' : ''
                        "></span>Otro
                      </label>
                    </div>
                    <input v-show="titularType == 'otro'" type="text" name="titularName" class="form__input"
                      style="margin-left: 10rem; margin-top: -3rem" placeholder="Ingresa el nombre del titular"
                      v-model="titularName" />
                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row v-if="buyerType == 'Propietario'" class="mt-5">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">Nombre del Asesor de ventas:</label>
                  </div>
                </mdb-col>
                <mdb-col md="4" style="margin-bottom: 10px" v-if="buyerType == 'Propietario'">
                  <div class="form__group">
                    <v-select label="name" id="name" class="form__input" :options="listBuyer" v-model="buyer"
                      :disabled="checked"></v-select>
                  </div>
                  <div>
                    <HelperMessage v-show="showErrorBuyer" type="error" text="Especifica un Asesor de Ventas" />
                  </div>
                </mdb-col>
                <!-- <mdb-col
                  md="6"
                  style="margin-bottom: 10px"
                  v-if="buyerType == 'Propietario'"
                >
                  <div class="form__group">
                    <div class="t1-checkbox ml-5">
                      <input
                        type="checkbox"
                        id="checkBuyer"
                        v-model="checked"
                      />
                      <label for="checkBuyer" class="form__label">
                        <span class="check-custom"></span>Otro
                      </label>
                    </div>
                    <div
                      v-show="checked"
                      style="margin-left: 10rem; margin-top: -2rem"
                    >
                      <input
                        type="text"
                        name="titularName"
                        class="form__input"
                        placeholder="Ingresa el Nombre del Asesor del Ventas"
                        v-model="otherBuyer"
                      />
                    </div>
                  </div>
                </mdb-col> -->
              </mdb-row>

              <!--FIN TIPO trámite-->
              <mdb-row class="mt-5">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">Selecciona el tipo de acción que deseas adquirir una vez
                      que seas Socio/Residente:</label>
                  </div>
                </mdb-col>
                <mdb-col v-for="m in memberships" :key="m.id" lg="3" md="4" sm="12" style="margin-bottom: 10px">
                  <div class="form__group">
                    <div class="form__check">
                      <input type="radio" name="shareType" :id="m.membershipName" v-model="shareType"
                        :value="m.membershipName" />
                      <label :for="m.membershipName">
                        <span :class="
                          shareType == m.membershipName
                            ? 'form__label-active'
                            : ''
                        "></span>
                        {{ m.membershipName }}
                      </label>
                    </div>
                    <input @mouseleave="mouseLeaveIcon(null)" @mouseover="mouseOverIcon(m.id)" type="image" :id="m.id"
                      :src="'/img/icons/' + helpIcon" />
                    <mdb-card v-if="showCard == m.id" style="
                                                          font-size: 15px;
                                                          position: absolute;
                                                          top: -7rem;
                                                          padding: 10px;
                                                          border-radius: 1rem;
                                                        ">{{ m.description }}</mdb-card>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label">
                      Datos de facturación para realizar el pago en línea por trámite de admisión(Datos de domicilio de la tarjeta)
                    </label>
                  </div>
                </mdb-col>
                  <mdb-col md="6" style="margin-bottom: 10px;">
                    <div class="form__group">
                      <div class="form__group">
                        <label class="form__label">CP.:</label>
                        <input v-model="codePostal" field="zip code" v-mask="'#####'" @input="getLocations" type="text"  class="form__input" value="" />
                                    <validation-error :validation="$v.codePostal" message="Introduce un código postal válido"/>
                      </div>
                    </div>
                  </mdb-col>
                  <mdb-col md="6" style="margin-bottom: 10px;">
                    <div class="form__group">
                      <div class="form__group">
                        <label class="form__label">Estado</label>
                        <input disabled v-model="state" field="state" type="text"  class="form__input" value="" style="background-color: #bdbdbd;" />
                      </div>
                    </div>
                  </mdb-col>
                  <mdb-col md="6" style="margin-bottom: 10px;">
                    <div class="form__group">
                      <div class="form__group">
                        <label class="form__label">Ciudad</label>
                        <input disabled v-model="city" field="ciity" type="text"  class="form__input" value="" style="background-color: #bdbdbd;"/>
                      </div>
                    </div>
                  </mdb-col>
                  <mdb-col md="6" style="margin-bottom: 10px;">
                    <div class="form__group">
                      <div class="form__group">
                        <label class="form__label">País</label>
                        <input disabled v-model="country" field="country" type="text"  class="form__input" value="" style="background-color: #bdbdbd;"/>
                                    <validation-error :validation="$v.country" message="Introduce un código postal válido"/>
                      </div>
                    </div>
                  </mdb-col>
                  <mdb-col md="6" style="margin-bottom: 10px;">
                    <div class="form__group">
                      <div class="form__group">
                        <label class="form__label">Calle y número</label>
                        <input v-model="street" field="street" type="text"  class="form__input" value="" />
                                    <validation-error :validation="$v.street" message="Introduce un código postal válido"/>
                      </div>
                    </div>
                  </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col class="text-right mt-5 mb-2">
                  <p class="t1-orange-text t1-subtitle">
                    TOTAL A PAGAR:
                    <b>${{ formatPrice(price) }}</b>
                  </p>
                </mdb-col>
              </mdb-row>
            </div>
          </div>
          <!-- <mdb-container style="width: 80%;">
            <p class="t1-text-warning">
              <img
                src="/img/icons/warning-orange.svg"
                style="margin-right: 5px;"
                width="15px"
                height="auto"
              />Para más información sobre el precio total de las acciones y sus beneficios da click en
              <span
                class="know-more"
              >Saber más...</span>
            </p>
          </mdb-container> -->
          <mdb-row class="mt-5 pb-5">
            <mdb-col class="text-right">
              <div class="btn-submit-docs">
                <btn style="display: inline; padding-right: 1rem" @onClick="$router.push('/home')" :type="'ghost'"
                  :text="'cancelar'" />
                <!-- <btn style="display: inline" :type="'primary'" @onClick="validation1" :text="'continuar'" /> -->
                <button v-show="showNetPayBtn === false" @click="toggle" 
                  style="color: #FFF;
                  height: 45px;
                  border-radius: 22px;
                  background-color: #0C71FF;
                  border: 1px solid lightgray;
                  font-size: 14px;
                  font-weight: 600;
                  letter-spacing: 0;
                  line-height: 19px;
                  text-align: center;
                  cursor: pointer;"
                  >
                  <span v-show="loadingStepBtn">cargando...</span>
                  <span v-show="!loadingStepBtn">Continuar</span>
                </button>
                <button 
                  v-show="showNetPayBtn === true"
                  class="netpay_btn"
                  id='netpay-checkout' 
                  data-button-title='Continuar'
                  data-onsuccess='onPaymentSuccess'
                  data-onerror='onPaymentError'
                  :data-commerce-name="variables.MERCHANT_NAME"
                  :data-product-count="dataPayment.count"
                  
                  :data-street1="dataPayment.street"
                  :data-country="dataPayment.country"
                  :data-city="dataPayment.city"
                  :data-postal-code="dataPayment.zipCode"
                  :data-state="dataPayment.state"
                  :data-phone-number="dataPayment.phone"
                  :data-email="dataPayment.email"
                  :data-merchant-reference-code="dataPayment.merchantReferenceCode"
                  :data-token="dataPayment.token"
                >
                  Continuar
                </button>
              </div>
            </mdb-col>
          </mdb-row>
        </div>
      </mdb-container>
    </div>
    <Popup ref="checkoutw" size="xs">
      <mdb-container class="paymentClass">
        <div class="checkout-title text-center">
          <img src="/img/icons/cart.svg" alt />
          <h4>PROCEDE A PAGAR</h4>
        </div>
        <div class="form__group mt-3">
          <label class="form__label" style="font-size: 1.5rem!important;">Formas de pago aceptadas: Débito y Crédito</label>
        </div>
        <mdb-row>
          <mdb-col md="12" sm="12" xs="12" class="text-center">
            <img src="/img/icons/MasterCard.svg" height="auto" width="35%"
              style="max-width: 50px; margin-right: 50px; display: inline" alt />
            <img src="/img/icons/Visa.svg" height="auto" width="35%"
              style="max-width: 50px; margin-right: 50px; display: inline" alt />
            <img src="/img/icons/AmericanExpress.svg" height="auto" width="30%" 
              style="max-width: 50px; display: inline"
              alt />
          </mdb-col>
        </mdb-row>
        <!--<div class="form__group mt-5">
          <label class="form__label">Nombre de tarjetahabiente</label>
          <input
            type="text"
            v-model="cardName"
            class="form__input text-center"
          />
          <validation-error
            field="nombre de tarjetahabiente"
            :validation="$v.cardName"
          />
        </div>-->
        <div class="form__group">
          <label class="form__label">Teléfono</label>
          <input v-model="telefono" v-mask="'###-###-####'" type="text" class="form__input text-center" />
          <validation-error type="minLength" message="Introduzca 10 números de teléfono" field="número de tarjeta"
            :validation="$v.telefono" />
        </div>
        <div class="form__group">
          <label class="form__label">No. Tarjeta</label>
          <input v-model="cardNumber" v-mask="['##### ###### ####', '#### #### #### ####']" type="text"
            class="form__input text-center" />
          <validation-error type="minLength"
            message="Introduzca al menos 16 caracteres para número de tarjeta, 15 si es AMEX." field="número de tarjeta"
            :validation="$v.cardNumber" />
        </div>
        <div class="row mb-3">
          <div class="col-8">
            <div class="form__group">
              <label class="form__label">Fecha de vencimiento</label>
              <input type="text" class="form__input text-center" v-model="cardMonth" v-mask="'##'" placeholder="MM"
                style="margin-right: 5px; width: 25%; display: inline" />
              <input type="text" class="form__input text-center" v-model="cardYear" v-mask="'##'" placeholder="AA"
                style="width: 25%; display: inline" />

              <validation-error type="minLength" message="Introduzca al menos 2 caracteres para mes de expiración"
                field="mes de expiración" :validation="$v.cardMonth" />
              <validation-error type="minLength" message="Introduzca al menos 2 caracteres para año de expiración"
                field="año de expiración" :validation="$v.cardYear" />
            </div>
          </div>
          <div class="col-4">
            <div class="form__group">
              <label class="form__label">CVC/CVV</label>
              <input type="password" v-model="cardCvcCvv" v-mask="cardType === 'AMEX' ? '####' : '###'"
                class="form__input" style="width: 50%; display: inline; text-align: center" />
              <validation-error field="CVC/CVV" type="minLength"
                message="Introduzca al menos 3 caracteres para cvv, 4 si es AMEX" :validation="$v.cardCvcCvv" />
            </div>
          </div>
        </div>
        <!-- ************************************************************************* -->

        <!--
        <div class="form__group">
          <div class="form__check">
            <input type="radio" name="netPayType" id="aceptada" v-model="tipoPrueba" value="Aceptada" />
            <label for="aceptada">
              <span :class="tipoPrueba == 'Aceptada' ? 'form__label-active' : ''"></span>
              Aceptada
            </label>
          </div>
          <div class="form__check">
            <input type="radio" name="netPayType" id="declinada" v-model="tipoPrueba" value="Declinada" />
            <label for="declinada">
              <span :class="tipoPrueba == 'Declinada' ? 'form__label-active' : ''"></span>
              Declinada
            </label>
          </div>
          <div class="form__check">
            <input type="radio" name="netPayType" id="3DSecure" v-model="tipoPrueba" value="3DSecure" />
            <label for="3DSecure">
              <span :class="tipoPrueba == '3DSecure' ? 'form__label-active' : ''"></span>
              3DSecure
            </label>
          </div>
        </div>
-->

        <!-- ************************************************************************* -->
        <div class="text-right">
          <h4 class="total-text" style="font-weight: 300; margin-top:1rem">
            TOTAL A PAGAR:
            <b>${{ formatPrice(price) }}</b>
          </h4>
        </div>
        
        <mdb-row v-if="procesingPay">
          <mdb-col>
            <p class="animated flash infinite text-center mt-5" style="font-size: 18px; color: red; font-weight: 400;">
              Procesando pago, no cierre la ventana
            </p>
          </mdb-col>
        </mdb-row>
        <div v-if="!procesingPay" class="btn-checkout text-right mt-3">
          <btn style="display: inline; padding-right: 1rem" @onClick="$refs.checkoutw.toggleModal()" type="default"
            :text="'cancelar'" />
          <btn style="display: inline" :type="'primary'" @onClick="preparePayment" :text="'pagar'" />
        </div>
      </mdb-container>
    </Popup>

    <Popup size="lg" ref="confirm" :title="titleModal">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh">
        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>
      </div>
      <div class="accordion__button">
        <btn style="float: left" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />
      </div>
    </Popup>
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol, mdbCard } from "mdbvue";
import Btn from "../core/Button";
import Popup from "../core/Popup";
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import ValidationError from "./misc/ValidationError";
import { required, requiredIf, minLength } from "vuelidate/lib/validators";
import { isValidMonth } from "../../validations";
import { Encrypt } from "../../utils/utils";
import Swal from "sweetalert2";
import { variables } from "../../variables";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import HelperMessage from "../core/HelperMessage";

export default {
  name: "PreparePayment",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    Btn,
    Popup,
    ValidationError,
    "v-select": vSelect,
    HelperMessage,
  },
  directives: { mask },
  data() {
    return {
      loadingStepBtn: false,
      /** CARD INFO */
      state:'',
      city:'',
      country:'Mexico',
      street:'',
      showNetPayBtn: false,
      codePostal: '',
      dataPayment: {
        count: 1,
        phone:'',
        email:'',
        
        // required values before init netpay button
        street:'',
        city:'',
        country:'',
        zipCode: '',
        state:'',
        merchantReferenceCode: '',
        token:'',
      },
      variables:variables,
      ProceedingType: "Adquirir Casa",
      propertyType: "casa",
      newOrTrasp: "nueva",
      ProceedingTypeUsuf: "rentacasa",
      paymentType: "Venta nueva",
      //shareTypeHouse: "familiar",
      ////////////
      buyerType: "Propietario",
      shareType: "Ejecutiva 3Px",
      //cardName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvcCvv: "",
      telefono: "",
      tipoPrueba: null,
      procesingPay: false,
      //////////
      titularType: "yo",
      titularName: "",
      listBuyer: [],
      buyer: null,
      otherBuyer: "",
      escUrl: null,
      escPDF: null,
      predialUrl: null,
      predialPDF: null,
      popUrl: null,
      checked: false,
      applicantT: [],
      titleModal: "",
      showErrorEscrituras: false,
      showErrorPredial: false,
      showErrorBuyer: false,
      helpIcon: "help-default.svg",
      showCard: false,
      //////
      domicilio: "",
      terreno: "",
      namePropietario: "",
      accion: "",
      //////
      deviceFingerPrint: "",
      tokenCard: "",
      referenceId: "",
      transaccionTokenId: "",
      procesing3ds: false
    };
  },

  validations: {
    domicilio: {
      required: requiredIf(function () {
        if (
          this.buyerType == "Propietario" &&
          this.ProceedingType == "Adquirir Casa"
        ) {
          return true;
        } else if (
          this.buyerType == "Usufructuario" &&
          (this.ProceedingType == "Rentar solo Casa" ||
            this.ProceedingType == "Renta Casa y Acción")
        ) {
          return true;
        } else {
          return false;
        }
      }),
    },
    terreno: {
      required: requiredIf(function () {
        if (this.buyerType == "Propietario") {
          return true;
        } else {
          return false;
        }
      }),
    },
    namePropietario: {
      required: requiredIf(function () {
        if (
          this.buyerType == "Usufructuario" ||
          this.paymentType == "Traspaso"
        ) {
          return true;
        } else {
          return false;
        }
      }),
    },
    accion: {
      required: requiredIf(function () {
        if (
          this.buyerType == "Usufructuario" &&
          (this.ProceedingType == "Rentar solo Acción" ||
            this.ProceedingType == "Renta Casa y Acción")
        ) {
          return true;
        } else {
          return false;
        }
      }),
    },

    /*cardName: {
      required,
    },*/
    cardNumber: {
      required,
      minLength: requiredIf(function () {
        if (this.cardType == "AMEX") {
          return minLength(15);
        } else return minLength(16);
      }),
    },
    cardMonth: {
      required,
      minLength: minLength(2),
      isValidMonth,
    },
    cardYear: {
      required,
      minLength: minLength(2),
    },
    cardCvcCvv: {
      required,
      minLength: requiredIf(function () {
        if (this.cardType == "AMEX") {
          return minLength(4);
        } else return minLength(3);
      }),
    },
    telefono: {
      required,
      minLength: minLength(10),
    },
    street: { required },
    codePostal: { required },
    country: { required },
    state: { required },
    city: { required },
  },
  watch: {
    async buyerType(value) {
      if (value == "Propietario") {
        this.ProceedingType = "Adquirir Casa";
      } else {
        this.ProceedingType = "Rentar solo Casa";
      }

      await this.getSelectedPrice();
    },
    async shareType() {
      await this.getSelectedPrice();
    },
    escUrl(value) {
      if (value != "") {
        this.showErrorEscrituras = false;
      }
    },
    predialUrl(value) {
      if (value != "") {
        this.showErrorPredial = false;
      }
    },
    checked(value) {
      if (!value) this.otherBuyer = "";
    },
    otherBuyer(value) {
      if (value != "") {
        this.showErrorBuyer = false;
      }
    },
    buyer(value) {
      if (value != null) {
        this.showErrorBuyer = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      applicantTypes: "getApplicantTypes",
      memberships: "getMemberships",
      salesTypes: "getSalesTypes",
      price: "getPriceSelected",
      applicationId: "getApplicationID",
      maritalStatus: "getMaritalStatus",
      fullName: "getFullName",
      solicitud: "getAllApplicationData",
    }),
    salesId() {
      let s = this.salesTypes
        .filter((s) => s.subProceedingTypeValue == this.paymentType)
        .map((s) => s.id);
      return s[0];
    },
    Proceedings() {
      let pc;
      let aux = this;
      if (aux.buyerType == "Propietario") {
        pc = aux.applicantT[0].proceedingTypes;
      } else {
        pc = aux.applicantT[1].proceedingTypes;
      }

      // pc.filter((pct) => pct.proceedingTypeValue == this.ProceedingType).map(
      //   (pct) => pct.id
      // );
      pc = pc.filter(function (pct) {
        return pct.proceedingTypeValue == aux.ProceedingType;
      });

      return pc[0].id;
    },
    applicantTypeId() {
      let at = this.applicantTypes
        .filter((at) => at.applicantTypeValue == this.buyerType)
        .map((at) => at.id);
      return at[0];
    },
    membershipId() {
      let m = this.memberships
        .filter((m) => m.membershipName == this.shareType)
        .map((m) => m.id);
      return m[0];
    },
    cardType() {
      // visa
      let re = new RegExp("^4");
      if (this.cardNumber.match(re) != null) return "Visa";

      // Mastercard
      // Updated for Mastercard 2017 BINs expansion
      re = new RegExp(
        "^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$"
      );
      if (this.cardNumber.match(re) != null) return "Mastercard";

      // AMEX
      re = new RegExp("^3[47]");
      if (this.cardNumber.match(re) != null) return "AMEX";

      // Visa Electron
      re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      if (this.cardNumber.match(re) != null) return "Visa Electron";

      return "";
    },
  },
  async mounted() {
    window.onPaymentSuccess = this._saveNetpayResponse
    window.onPaymentError = this._saveNetpayResponse
    await this._redirectOnLoad()
    let date = new Date();
    let timestamp = date.getTime();

    await this.getApplicantTypes();
    await this.getMemberships();
    await this.getSelectedPrice();

    let response = await this.getListOfBuyers();

    let auxBuyers = response.data.data;
    for (let index in auxBuyers) {
      let aux = {
        id: auxBuyers[index].id,
        name:
          auxBuyers[index].name +
          " " +
          auxBuyers[index].lastName +
          " " +
          auxBuyers[index].mothersLastName,
      };
      this.listBuyer.push(aux);
    }

    var byDate = this.applicantTypes.slice(0);
    byDate.sort(function (a, b) {
      var x = a.applicantTypeValue.toLowerCase();
      var y = b.applicantTypeValue.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });
    this.applicantT = byDate;

    this.checkPayment();

    /** Configure Netpay Keys */

    /** Configure Test Mode */
    // NetPay.setApiKey("pk_netpay_ttmvhSLFUxnNPKgNhMOLCMSed");
    // NetPay.setSandboxMode(true);
    // netpay3ds.setSandboxMode(true);

    /** Configure Productive Mode */
    // NetPay.setApiKey("pk_netpay_nZCBaTcHhEZqaAWVRlvDqZxbo");
    // NetPay.setSandboxMode(false);
    // netpay3ds.setSandboxMode(false);

    // this.deviceFingerPrint = NetPay.form.generateDeviceFingerPrint();
    this._reloadPageOnCloseNetPayModal()
  },
  methods: {
    ...mapActions([
      "getApplicantTypes",
      "getMemberships",
      "getPrice",
      "exePayment",
      "setPaymentDoneData",
      "logOut",
      "getListOfBuyers",
      "getListSalesTypes",
      "postStep2",
      "postStep3",
      "check3DSecure",
      "tokenizeAmount",
      "registerPaymentPlus",
      "obtainLocationsDoc",
    ]),
    _reloadPageOnCloseNetPayModal(){
      const time_ms = 1000
      const webClose  = setInterval(() => {
        const target = document.querySelector('#close-modal')

        if (!target) return
        target.addEventListener('click', () => {
          window.location.reload(true)
        })

        clearInterval(webClose)
      }, time_ms);
      const mobileClose = setInterval(() => {
        const target = document.querySelector('.NP-icon-cross-light.np-close-button.np-close-modal')
        if (!target) return
        target.addEventListener('click', ()=>{
          window.location.reload(true)
        })

        clearInterval(mobileClose)
      }, time_ms);
    },
    async getLocations() {
      if (this.codePostal.length !== 5) {
        this.state = ''
        this.city = ''
        return
      }
      try {
        const response = await this.obtainLocationsDoc(this.codePostal);
        if (response.data) {
          this.state = response.data.data[0].state;
          this.city = response.data.data[0].city!=''?response.data.data[0].city:response.data.data[0].municipality;
        }
      } catch (error) {
        console.log(error);
        this.state = ''
        this.city = ''
      }
    },
    _setNetPay(){
      return new Promise((res, _) => {
        const a = setTimeout(() => {
          window.NetPay.init(variables.PUBLIC_KEY)
          window.NetPay.setSandboxMode(variables.isProd === false)
          res()
          clearTimeout(a)
        }, 500);
      })
    },
    _resetNetPayBtnValues(){
      this.dataPayment.phone =''
      this.dataPayment.email =''
      
      // required values before init netpay button
      this.dataPayment.street = ''
      this.dataPayment.city = ''
      this.dataPayment.country = 'Mexico'
      this.dataPayment.zipCode = ''
      this.dataPayment.state = ''
      this.dataPayment.merchantReferenceCode =  this.applicationId
      this.dataPayment.token = ''
    },
    _setNetPayBtnValues(tokenizedAmount){
      // required values before init netpay button
      this.dataPayment.street = this.street
      this.dataPayment.city = this.city
      this.dataPayment.country = this.country
      this.dataPayment.zipCode =  this.codePostal
      this.dataPayment.state = this.state
      this.dataPayment.merchantReferenceCode =  this.applicationId
      this.dataPayment.token = tokenizedAmount
    },
    _addN(netPayId = 'netPayScript'){
      const scriptEle = document.createElement("script");
      scriptEle.setAttribute("src", this.variables.NETPAY_API_URL);
      scriptEle.setAttribute("id", netPayId);
      scriptEle.setAttribute("type", "text/javascript");
      document.body.appendChild(scriptEle);
      scriptEle.addEventListener("load", () => {
      });
      scriptEle.addEventListener("error", (ev) => {
        console.log("Error on loading file", ev);
      });
    },
    _clickNetPayBtn(id = 'netpay-checkout'){
        setTimeout(() => {
          document.querySelector(`#${id}`).click() 
        }, 300);
    },
    async toggle(){
      this.$v.domicilio.$touch();
      this.$v.codePostal.$touch();
      this.$v.country.$touch();
      this.$v.street.$touch();
      this.$v.accion.$touch();
      this.$v.terreno.$touch();
      this.$v.namePropietario.$touch();

      let isInvalidForm = true


      if (this.buyerType == "Propietario") {
          if (this.paymentType == "Traspaso") {
            if (
              this.escUrl != null &&
              this.predialUrl != null &&
              (this.buyer != null || this.otherBuyer != "")
            ) {
              // console.log(1);
              isInvalidForm = false
            } else {
              this.escUrl == null
                ? (this.showErrorEscrituras = true)
                : (this.showErrorEscrituras = false);
              this.predialUrl == null
                ? (this.showErrorPredial = true)
                : (this.showErrorPredial = false);
              this.buyer == null && this.otherBuyer == ""
                ? (this.showErrorBuyer = true)
                : (this.showErrorBuyer = false);
                // console.log(1);
                isInvalidForm = true
            }
          } else {
            if (this.buyer != null || this.otherBuyer != "") {
              // console.log(1);
              isInvalidForm = false
            } else {
              // console.log(1);
              isInvalidForm = true
              this.buyer == null && this.otherBuyer == ""
                ? (this.showErrorBuyer = true)
                : (this.showErrorBuyer = false);
            }
          }
        } else {
          // console.log(1);
          isInvalidForm = false
        }

      // INVALID FORM
      if (
        isInvalidForm||
        this.$v.domicilio.$invalid ||
        this.$v.codePostal.$invalid ||
        this.$v.country.$invalid ||
        this.$v.street.$invalid ||
        this.$v.state.$invalid ||
        this.$v.city.$invalid ||
        this.$v.accion.$invalid ||
        this.$v.terreno.$invalid ||
        this.$v.namePropietario.$invalid
      ) {
        return
      }
// console.log('ok');
      Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>Una vez realizado el pago por el trámite de tu admisión, éste <span style='font-weight: 600;'>no será susceptible de reembolso ni devolución.</span></p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          showCancelButton: true,
          width: "50rem",
          padding: "2rem",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#dc7134",
          customClass: {
            cancelButton: "t1-btn t1-btn--ghost",
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          reverseButtons: true,
          onClose: () => { },
        }).then((result) => {
          if (result.isConfirmed) {
            this._triggerNetPay()
          }
        });
    },
    async _triggerNetPay(){
      let response
      this.loadingStepBtn = true
      try {
        response = await this.tokenizeAmount({ "amount": this.price });
      } catch (error) {
        console.log(error);
        this.loadingStepBtn = false
        return
      }

      const netPayScriptId = 'netPayScript'
      const netPayBtnId = 'netpay-checkout'
      
      this._addN(netPayScriptId)
      
      this.showNetPayBtn = true
      this.loadingStepBtn = false
      this._setNetPayBtnValues(response.data.data.tokenAmount)
      await this._setNetPay()
      this._clickNetPayBtn(netPayBtnId)
    },
    _parserNetpayResponse(res){
      try {
        return Encrypt(JSON.stringify(res))
      } catch (error) {
        return undefined
      }
    },
    async _saveNetpayResponse(netPayResponse){
      if (await this._saveFormData() === undefined) return
      try {
        const temp = {
          "applicantTypeId": this.applicantTypeId,
          "applicationFolio": this.applicationId,
          "membershipId": this.membershipId,
          ...netPayResponse
        }
        const response = await this.registerPaymentPlus({ data: this._parserNetpayResponse(structuredClone(temp))});
        await this._redirect(response)
      } catch (error) {
        console.log(error);
      }
    },
    _redirectOnLoad(){
      if(localStorage.getItem('payment_approved') === 'true') {
        this.$router.push("/home/paymentdone");
      }
    },
    async _redirect(response){
      if (response !== undefined) {
        let dataRedir = {};
        dataRedir.name = response.data.data.applicantName;
        dataRedir.shareType = response.data.data.membershipType;
        dataRedir.status = response.data.data.paymentStatus;
        dataRedir.total = response.data.data.total;
  
        await this.setPaymentDoneData(JSON.stringify(dataRedir));
        localStorage.setItem("payment_approved", true);
        return
      }

      this.$router.push("/home/paymentdone");
      this.procesing3ds = false;
      return;
      //IR A PASO 2
    },
    async _saveFormData(){
      try {
        await this.saveDataProceeding()
        return true
      } catch (error) {
        console.log(error);
        this.$notify.error({
          message: 'Error al guardar los datos',
          position: "top right",
          timeOut: 5000,
        });
        return
      }
    },
    /** Netpay Callbacks */
    async confirmTransaction(processorTransactionId) {

      try {
        let response = await this.check3DSecure(
          { "token": this.transaccionTokenId, "processorTransactionId": processorTransactionId }
        );
        if (response.data.status == 200) {

          this.$notify.success({
            message: response.data.message,
            position: "top right",
            timeOut: 5000,
          });
          let dataRedir = {};
          dataRedir.name = response.data.data.applicantName;
          dataRedir.shareType = response.data.data.membershipType;
          dataRedir.status = response.data.data.paymentStatus;
          dataRedir.total = response.data.data.total;

          await this.setPaymentDoneData(JSON.stringify(dataRedir));
          localStorage.setItem("payment_approved", true);
          this.$router.push("/home/paymentdone");
          this.procesing3ds = false;
          return;
        } else {
          Swal.fire({
            icon: "error",
            title:
              "Transacción rechazada  : CODE02",
            text: "Tu banco rechazo esta transacción, es necesario que los contactes para validar que no tengas restricciones para hacer pagos en linea. Por motivos de seguridad te pedimos que por favor vuelvas a iniciar sesión e intentes nuevamente realizar tu pago.",
            allowOutsideClick: false,
          }).then(() => {
            this.logout();
          });
          this.procesing3ds = false;
          return;
        }
      } catch (e) {
        let validText =
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p><span style='font-weight: 600; color: #dc7134 !important; '>" +
          (e.hasOwnProperty("response") ? e.response.data.message : "La transacción no fue confirmada") +
          "</span> <br/> Por favor vuelve a intentar con otra tarjeta o comunícate con tu banco para más detalles.</p>" +
          "</div>";

        Swal.fire({
          icon: "error",
          title: "No se pudo completar el pago.",
          html: validText,
          allowOutsideClick: false,
        }).then(() => {
          this.procesingPay = false;
          this.cardNumber = "";
          this.cardMonth = "";
          this.cardYear = "";
          this.cardCvcCvv = "";
          // this.logout()
        });
        this.procesing3ds = false;
        return;

      }

    },
    callbackProceed(_this, processorTransactionId, status) {
      if (this.procesing3ds == true) {
        this.procesing3ds = false;
        if (status == 'success') {
          return this.confirmTransaction(processorTransactionId);
        }
        else {
          Swal.fire({
            icon: "error",
            title:
              "Transacción rechazada : CODE01 " + status,
            text: "Tu banco rechazo esta transacción, es necesario que los contactes para validar que no tengas restricciones para hacer pagos en linea. Por motivos de seguridad te pedimos que por favor vuelvas a iniciar sesión e intentes nuevamente realizar tu pago.",
            allowOutsideClick: false,
          }).then(() => {
            this.logout();
          });

          return;
        }
      } else {
        return;
      }
    },
    async success3ds(_this, referenceId) {
      try {
        let data = {};
        this.referenceId = referenceId;
        data.tipoPrueba = this.tipoPrueba;
        data.total = this.price;
        data.cardNumber = this.cardNumber.replace(/\s/g, "");
        data.expirationMonth = this.cardMonth;
        data.expirationYear = this.cardYear;
        data.cvv = this.cardCvcCvv;
        data.cardType = this.cardType;
        //data.cardHolderName = this.cardName;
        data.applicantTypeId = this.applicantTypeId;
        data.membershipId = this.membershipId;
        data.applicationFolio = this.applicationId;
        data.phone = this.telefono.replace(/-/g, "");
        data.tokenCard = this.tokenCard;
        data.deviceFingerPrint = this.deviceFingerPrint;
        data.sessionId = this.deviceFingerPrint;
        data.referenceId = this.referenceId
        let response = await this.saveDataProceeding();

        if (response) {
          response = await this.exePayment(Encrypt(JSON.stringify(data)));
        } else {
          this.procesingPay = false;
          this.procesing3ds = false;
          return;
        }

        if (response.data.status == 200) {

          if (response.data.message == "Validar por 3DS.") {
            let _this = this
            this.transaccionTokenId = response.data.data.transaccionTokenId
            let canProceed = await netpay3ds.canProceed("review", response.data.data.responseCode, response.data.data.acsUrl);
            if (canProceed) {
              netpay3ds.proceed(_this, response.data.data.acsUrl, response.data.data.paReq, response.data.data.authenticationTransactionID, this.callbackProceed);
            }
            else {
              if (this.procesing3ds == true) {
                await this.confirmTransaction(null)
              }
            }
          } else {
            this.$notify.success({
              message: response.data.message,
              position: "top right",
              timeOut: 5000,
            });
            let dataRedir = {};
            dataRedir.name = response.data.data.applicantName;
            dataRedir.shareType = response.data.data.membershipType;
            dataRedir.status = response.data.data.paymentStatus;
            dataRedir.total = response.data.data.total;

            await this.setPaymentDoneData(JSON.stringify(dataRedir));
            localStorage.setItem("payment_approved", true);
            this.$router.push("/home/paymentdone");
            this.procesing3ds = false;
            return;
            //IR A PASO 2
          }
        } else {
          Swal.fire({
            icon: "error",
            title:
              "Ups... hemos tenido un incoveniente para poder procesar tu pago.",
            text: "Te informamos que tu pago no se realizó, y por motivos de seguridad te pedimos que por favor vuelvas a iniciar sesión e intentes nuevamente realizar tu pago.",
            allowOutsideClick: false,
          }).then(() => {
            this.logout();
          });
          this.procesing3ds = false;
          return;
        }
      } catch (e) {
        this.procesingPay = false;

        if (e.response.data.status == 406) {  // Caso de pago rechazado 
          let validText =
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p><span style='font-weight: 600; color: #dc7134 !important; '>" +
            e.response.data.message +
            "</span> <br/> Por favor vuelve a intentar con otra tarjeta o comunícate con tu banco para más detalles.</p>" +
            "</div>";

          Swal.fire({
            icon: "error",
            title: "No se pudo completar el pago.",
            html: validText,
            allowOutsideClick: false,
          }).then(() => {
            this.procesingPay = false;
            //this.cardName = "";
            this.cardNumber = "";
            this.cardMonth = "";
            this.cardYear = "";
            this.cardCvcCvv = "";
          });
          this.procesing3ds = false;
          return;
        } else {
          Swal.fire({
            icon: "error",
            title: "Ups... hemos tenido un incoveniente para poder procesar tu pago.",
            text: "Te informamos que tu pago no se realizó, y por motivos de seguridad te pedimos que por favor vuelvas a iniciar sesión e intentes nuevamente realizar tu pago.",
            allowOutsideClick: false,
          }).then(() => {
            this.logout();
          });
          this.procesing3ds = false;
          return;
        }
      }
    },
    errorCallback(e) {
      let validText =
        "<br/><div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
        "<p> Por favor revisa que los datos de tu tarjeta sean correctos.<br/> <span style='font-weight: 600;'></div>" +
        "<div style='text-align: left; padding-right: 1rem; padding-left: 1rem; font-size: 16px; font-family: Open Sans' color: #828282'><ul>" +
        e.message +
        "</ul></p>" +
        "</div>";

      Swal.fire({
        icon: "warning",
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>Datos incorrectos.</span>",
        html: validText,
        allowOutsideClick: false,
      }).then(() => {
        this.procesingPay = false;
      });
    },
    async successCallback(e) {
      this.procesing3ds = true;
      this.tokenCard = JSON.parse(e.message.data).token;
      let _this = this;
      netpay3ds.setSandboxMode(false);
      netpay3ds.init(function () {
        netpay3ds.config(_this, _this.price, _this.success3ds);
      });

    },
    async checkout(cardInformation) {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        Swal.fire({
          title:
            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
          html:
            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p>Una vez realizado el pago por el trámite de tu admisión <span style='font-weight: 600;'>no hay devoluciones</span></p>" +
            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
            "</div>",
          allowOutsideClick: false,
          showCancelButton: true,
          width: "50rem",
          padding: "2rem",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#dc7134",
          customClass: {
            cancelButton: "t1-btn t1-btn--ghost",
            confirmButton: "t1-btn t1-btn--primary-block",
          },
          reverseButtons: true,
          onClose: () => { },
        }).then((result) => {
          if (result.value) {
            this.procesingPay = true;
            window.NetPay.token.create(
              cardInformation,
              this.successCallback,
              this.errorCallback
            );
          }
        });
      }
    },
    preparePayment() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        /** Netpay Validation */
        let cardInformation = {
          cardNumber: this.cardNumber.replace(/\s/g, ""),
          expMonth: this.cardMonth,
          expYear: this.cardYear,
          cvv2: this.cardCvcCvv,
          vault: true,
          simpleUse: false,
          deviceFingerPrint: this.deviceFingerPrint
        };

        var validateNumber = window.NetPay.card.validateNumber(
          cardInformation.cardNumber
        );

        var validateExpiry = window.NetPay.card.validateExpiry(
          cardInformation.expMonth,
          cardInformation.expYear
        );

        var validateCVV = window.NetPay.card.validateCVV(
          cardInformation.cvv2,
          cardInformation.cardNumber
        );

        var validateNumberLength = window.NetPay.card.validateNumberLength(
          cardInformation.cardNumber
        );

        if (
          validateNumber &&
          validateExpiry &&
          validateCVV &&
          validateNumberLength
        ) {
          this.checkout(cardInformation);
        } else {
          /** Invlaid card data */
          let validText =
            "<br/><div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            "<p> Por favor revisa que los datos de tu tarjeta sean correctos.<br/> </p></div>" +
            "<div style='text-align: left; padding-right: 1rem; padding-left: 1rem; font-size: 16px; font-family: Open Sans' color: #828282'><ul>" +
            (validateNumber ? ""
              : "<li>Número de tarjeta invalido. <br/></li>") +
            (validateNumberLength
              ? ""
              : "<li>Longitud de número de tarjeta invalido. <br/></li>") +
            (validateExpiry ? "" : "<li>Vigencia invalida. <br/></li>") +
            (validateCVV ? "" : "<li>CVV invalido. <br/></li>") +
            "</ul></p>" +
            "</div>";

          Swal.fire({
            icon: "warning",
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>Datos incorrectos.</span>",
            html: validText,
            allowOutsideClick: false,
          }).then(() => {
            this.procesingPay = false;
          });
        }
      }
    },




    /** --------------------------------------------------------- */
    cleanInputFile(id) {
      document.getElementById(id).value = "";
    },
    checkPayment() {
      if (this.solicitud.application.applicantType)
        this.buyerType =
          this.solicitud.application.applicantType.applicantTypeValue;

      if (this.solicitud.application.proceedingType)
        this.ProceedingType =
          this.solicitud.application.proceedingType.proceedingTypeValue;

      if (this.solicitud.application.previousOwner)
        this.namePropietario = this.solicitud.application.previousOwner;

      if (this.solicitud.application.numberAction)
        this.accion = this.solicitud.application.numberAction;

      if (this.solicitud.application.numberGround)
        this.terreno = this.solicitud.application.numberGround;

      if (this.solicitud.application.addressGround)
        this.domicilio = this.solicitud.application.addressGround;

      if (this.solicitud.application.subProceedingType)
        this.paymentType =
          this.solicitud.application.subProceedingType.subProceedingTypeValue;

      if (this.solicitud.application.owner) {
        let name =
          this.solicitud.name +
          " " +
          this.solicitud.lastName +
          " " +
          this.solicitud.mothersLastName;
        if (this.solicitud.application.owner == name) this.titularType = "yo";
        else {
          this.titularType = "otro";
          this.titularName = this.solicitud.application.owner;
        }
      }

      if (this.solicitud.application.seller)
        this.buyer = this.solicitud.application.seller;

      if (this.solicitud.application.membership) {
        this.shareType = this.solicitud.application.membership.membershipName;
      }

      let predial = this.solicitud.documents.filter(function (item) {
        return item.documentType == "PROPERTY_PAYMENT";
      });

      let escrituras = this.solicitud.documents.filter(function (item) {
        return item.documentType == "DEED_OR_AGREEMENT";
      });

      if (predial.length > 0) {
        this.predialUrl = predial[0].publicURL;
      }

      if (escrituras.length > 0) {
        this.escUrl = escrituras[0].publicURL;
      }
    },
    mouseOverIcon(index) {
      // let helpIcon = this.helpIcon.split("-");
      // this.helpIcon = `${helpIcon[0]}-hover.svg`;
      this.showCard = index;
    },
    mouseLeaveIcon() {
      // let helpIcon = this.helpIcon.split("-");
      // this.helpIcon = `${helpIcon[0]}-default.svg`;
      this.showCard = null;
    },
    // async getSalesTypes() {
    //   let response = await this.getListSalesTypes()
    //   this.salesTypes = response.data.data;
    // },
    uploadEscritura: function (evt) {
      this.escUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.escPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadPredial: function (evt) {
      this.predialUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.predialPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    viewPdf(url, title) {
      this.popUrl = url;
      this.titleModal = title;
      this.$refs.confirm.toggleModal();
    },
    async logout() {
      await this.logOut();
      this.$router.push("/");
    },
    async getSelectedPrice() {
      await this.getPrice({
        membershipId: this.membershipId,
        applicantTypeId: this.applicantTypeId,
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async saveDataProceeding() {
      let body = {};
      let body2 = {};
      if (this.buyerType == "Propietario") {
        body = {
          proceedingTypeId: this.Proceedings,
          subProceedingTypeId: this.salesId,
          seller: this.checked ? this.otherBuyer : this.buyer.name,
          applicantTypeId: this.applicantTypeId,
          membershipId: this.membershipId,
          owner: this.titularType == "yo" ? this.fullName : this.titularName,
          addressGround: null,
          numberGround: null,
          numberAction: null,
          previousOwner: null,
        };

        if (this.ProceedingType == "Adquirir Casa") {
          body.addressGround = this.domicilio;
          body.numberGround = this.terreno;
          if (this.paymentType == "Traspaso") {
            body.previousOwner = this.namePropietario;
          }
        } else {
          body.numberGround = this.terreno;
          if (this.paymentType == "Traspaso") {
            body.previousOwner = this.namePropietario;
          }
        }

        //this.$store.commit("setProceedingData", body);

        if (
          this.paymentType == "Traspaso" &&
          this.escPDF != null &&
          this.predialPDF != null
        ) {
          body2 = {
            documentsDTO: [
              {
                documentType: "DEED_OR_AGREEMENT",
                value: "",
                extension: "pdf",
                mimeType: "application/pdf",
                content: this.escPDF,
              },
              {
                documentType: "PROPERTY_PAYMENT",
                value: "",
                extension: "pdf",
                mimeType: "application/pdf",
                content: this.predialPDF,
              },
            ],
          };
        }
      } else {
        ///Usufructuario
        body = {
          applicantTypeId: this.applicantTypeId,
          membershipId: this.membershipId,
          proceedingTypeId: this.Proceedings,
          addressGround: null,
          numberGround: null,
          numberAction: null,
          previousOwner: this.namePropietario,
        };
        if (this.ProceedingType == "Rentar solo Casa") {
          body.addressGround = this.domicilio;
        }
        if (this.ProceedingType == "Rentar solo Acción") {
          body.numberAction = this.accion;
        }
        if (this.ProceedingType == "Renta Casa y Acción") {
          body.addressGround = this.domicilio;
          body.numberAction = this.accion;
        }
      }

      try {
        let response = await this.postStep2(body);
        if (
          response.data.status == 200 &&
          this.paymentType == "Traspaso" &&
          this.escPDF != null &&
          this.predialPDF != null
        ) {
          await this.postStep3(body2);
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    validation1() {
      this.$v.domicilio.$touch();
      this.$v.accion.$touch();
      this.$v.terreno.$touch();
      this.$v.namePropietario.$touch();

      if (
        !this.$v.namePropietario.$invalid &&
        !this.$v.domicilio.$invalid &&
        !this.$v.terreno.$invalid &&
        !this.$v.accion.$invalid
      ) {
        if (this.buyerType == "Propietario") {
          if (this.paymentType == "Traspaso") {
            if (
              this.escUrl != null &&
              this.predialUrl != null &&
              (this.buyer != null || this.otherBuyer != "")
            ) {
              this.$refs.checkoutw.toggleModal();
            } else {
              this.escUrl == null
                ? (this.showErrorEscrituras = true)
                : (this.showErrorEscrituras = false);
              this.predialUrl == null
                ? (this.showErrorPredial = true)
                : (this.showErrorPredial = false);
              this.buyer == null && this.otherBuyer == ""
                ? (this.showErrorBuyer = true)
                : (this.showErrorBuyer = false);
            }
          } else {
            if (this.buyer != null || this.otherBuyer != "") {
              this.$refs.checkoutw.toggleModal();
            } else {
              this.buyer == null && this.otherBuyer == ""
                ? (this.showErrorBuyer = true)
                : (this.showErrorBuyer = false);
            }
          }
        } else {
          this.$refs.checkoutw.toggleModal();
        }
      }
    },

  }
};
</script>

<style lang="scss">
.swal2-container {
  z-index: 20000 !important;
}

.swal2-styled.swal2-cancel {
  border-radius: 0.5em;
  background: initial;
  background-color: #aaa;
  color: #fff;
  font-size: 1.0625em;
  background-color: transparent;
  border: 2px solid #828282;
  color: #828282;
  padding: 0.55em 1.5em;
}

.proceeding-type-container {
  border: 1px solid #3a8a65;
  border-radius: 5px;
  max-width: 80%;
  padding: 5rem;
}

.t1-text-warning {
  margin-top: 1rem;
  font-size: 1.4rem;
  color: #828282;
  font-weight: 300;
}

.know-more {
  color: #dc7134;
  font-weight: bold;
  cursor: pointer;
}

.checkout-title {
  position: relative;
}

.checkout-title img {
  height: 2.5rem;
  width: 2.5rem;
  margin-top: -0.5rem;
}

.checkout-title h4 {
  display: inline;
  padding-left: 1rem;
  font-size: 2rem;
  color: #828282;
  font-weight: 500;
}

.total-text {
  color: #828282;
  font-weight: 600;
}

.form-margins {
  margin-left: 50px;
  margin-right: 50px;
}

.btn-label {
  border-radius: 5px;
  background-color: #dc7134;
  padding: 0.4rem 2.5rem;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: Josefin Sans;
  cursor: pointer;
}

.btn-delete {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.help-curp {
  width: 29rem;
  position: absolute;
  bottom: 0rem;
  z-index: 10000;
}

@media (max-width: 80.2rem) {
  .paymentClass {
    height: 50rem;
    overflow: auto;
  }
}

@media (max-width: 1920px) {
  .popup__content.popup__content--xs {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 10px;
    padding-top:30px ;
  }

  .paymentClass.container {
    height: 53vh;
  }
}

@media (max-width: 1680px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 53vh;
    width: 25vw;
  }
}

// @media (max-width: 1618px) {
//   .popup__content.popup__content--xs {
//     padding-left: 25px;
//     padding-right: 25px;
//   }
// }

@media (max-width: 1600px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 68vh;
    width: 27vw;
  }
}

@media (max-width: 1440px) and (max-height: 1050px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 53vh;
    width: 30vw;
  }
}

@media (max-width: 1440px) and (max-height: 900px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 68vh;
    width: 30vw;
  }
}

@media (max-width: 1366px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 81vh;
    width: 32vw;
  }
}

@media (max-width: 1280px) and (max-height: 1024px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 62vh;
    width: 32vw;
  }
}

@media (max-width: 1280px) and (max-height: 800px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 77vh;
    width: 34vw;
  }
}

@media (max-width: 1280px) and (max-height: 768px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 81vh;
    width: 34vw;
  }
}

@media (max-width: 1280px) and (max-height: 720px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;
  }

  .paymentClass.container {
    height: 88vh;
    width: 34vw;
  }
}

@media (max-width: 1024px) {
  .popup__content.popup__content--xs {
    padding-left: 50px;
    padding-right: 50px;

  }

  .paymentClass.container {
    height: 81vh;
    width: 42vw;
  }
}

@media (max-width: 800px) {
  .popup__content.popup__content--xs {
    padding-left: 0px;
    padding-right: 0px;
    height: 99vh;
  }

  .paymentClass.container {
    width: 55vw;
  }
}

@media (max-width: 768px) {
  .popup__content.popup__content--xs {
    padding-left: 50px;
    padding-right: 50px;

  }

  .paymentClass.container {
    height: 89vh;
  }
}

@media (max-width: 425px) {
  .popup__content.popup__content--xs {
    padding-left: 20px;
    padding-right: 20px;

  }

  .paymentClass.container {
    height: 91vh;
  }
}

@media (max-width: 320px) {
  .popup__content.popup__content--xs {
    padding-left: 10px;
    padding-right: 10px;

  }

  .paymentClass.container {
    height: 91vh;
  }

  img {
    margin-right: 20px !important;
  }
}

@media (max-height: 800px) {
  .paymentClass {
    height: 50rem;
    overflow: auto;
  }
}
</style>
<style scoped>
.netpay_btn{
  color: #FFF;
  height: 45px;
  border-radius: 22px;
  background-color: #0C71FF;
  border: 1px solid lightgray;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
}
</style>